import { render, staticRenderFns } from "./PeppolStatusField.vue?vue&type=template&id=ff278c58"
import script from "./PeppolStatusField.vue?vue&type=script&lang=js"
export * from "./PeppolStatusField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports